<div class="supply-history-page">
  <div class="header">
    <h2>Supply Dispatch History & Analytics</h2>
    <div class="actions">
      <button mat-flat-button color="primary" (click)="runFilter()">Apply Filter</button>
      <button mat-stroked-button (click)="resetFilters()">Reset</button>
    </div>
  </div>

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>From</mat-label>
      <input matInput type="date" [(ngModel)]="filters.from" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>To</mat-label>
      <input matInput type="date" [(ngModel)]="filters.to" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Product Type</mat-label>
      <mat-select [(value)]="filters.productTypeId" (selectionChange)="onTypeChange()">
        <mat-option [value]="null">All Types</mat-option>
        <mat-option *ngFor="let t of productTypes" [value]="t.id">{{ t.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Item Type</mat-label>
      <mat-select [(value)]="filters.productItemId">
        <mat-option [value]="null">All Items</mat-option>
        <mat-option *ngFor="let i of productItems" [value]="i.id">{{ i.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="filters.search" placeholder="Buyer, origin, destination..." />
    </mat-form-field>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="analytics-grid" *ngIf="analytics">
    <div class="stat-card">
      <div class="title">Dispatch Entries</div>
      <div class="value">{{ analytics.totalDispatches }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Total Units</div>
      <div class="value">{{ analytics.totalUnits | number:'1.2-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Gross Amount</div>
      <div class="value">₦{{ analytics.grossAmount | number:'1.2-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Commission</div>
      <div class="value">₦{{ analytics.totalCommission | number:'1.2-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Net Amount</div>
      <div class="value">₦{{ analytics.netAmount | number:'1.2-2' }}</div>
    </div>
  </div>

  <table mat-table [dataSource]="rows" class="full-table mat-elevation-z1">
    <ng-container matColumnDef="dispatchDate">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let row">{{ row.dispatchDate | date:'mediumDate' }}</td>
    </ng-container>

    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef>Product</th>
      <td mat-cell *matCellDef="let row">{{ row.productTypeName }} / {{ row.productItemName }}</td>
    </ng-container>

    <ng-container matColumnDef="buyerName">
      <th mat-header-cell *matHeaderCellDef>Buyer</th>
      <td mat-cell *matCellDef="let row">{{ row.buyerName }}</td>
    </ng-container>

    <ng-container matColumnDef="origin">
      <th mat-header-cell *matHeaderCellDef>From</th>
      <td mat-cell *matCellDef="let row">{{ row.origin || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="destination">
      <th mat-header-cell *matHeaderCellDef>To</th>
      <td mat-cell *matCellDef="let row">{{ row.destination || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="unitCount">
      <th mat-header-cell *matHeaderCellDef>Units</th>
      <td mat-cell *matCellDef="let row">{{ row.unitCount | number:'1.2-2' }}</td>
    </ng-container>

    <ng-container matColumnDef="unitPrice">
      <th mat-header-cell *matHeaderCellDef>Unit Price</th>
      <td mat-cell *matCellDef="let row">₦{{ row.unitPrice | number:'1.2-2' }}</td>
    </ng-container>

    <ng-container matColumnDef="commissionAmount">
      <th mat-header-cell *matHeaderCellDef>Commission</th>
      <td mat-cell *matCellDef="let row">₦{{ row.commissionAmount | number:'1.2-2' }}</td>
    </ng-container>

    <ng-container matColumnDef="totalAmount">
      <th mat-header-cell *matHeaderCellDef>Gross</th>
      <td mat-cell *matCellDef="let row">₦{{ row.totalAmount | number:'1.2-2' }}</td>
    </ng-container>

    <ng-container matColumnDef="netAmount">
      <th mat-header-cell *matHeaderCellDef>Net</th>
      <td mat-cell *matCellDef="let row">₦{{ (row.totalAmount - row.commissionAmount) | number:'1.2-2' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
